<template>
  <v-flex id="scroll-target" :style="scrollStyle"
          class="sfh-login-form background-image scrollbar scroll-style-15">

    <v-layout column style="height:100%">
      <v-flex :style="styleObj" >
        <v-layout row fill-height wrap v-scroll:#scroll-target="onScroll">

          <span style="visibility: hidden;height: 0;width: 0;" id="reachMeFromBottom">&nbsp;</span>

          <slot></slot>

        </v-layout>
      </v-flex>
      <v-flex
        style="display: flex;flex-direction: column-reverse;"
      >
        <app-footer v-if="footer"/>
      </v-flex>
    </v-layout>

  </v-flex>
</template>

<script>
  import AppFooter from './layouts/Footer'
  export default {
    name: 'ScrollData',
    props: {
      footer: {
        default: true,
        type: Boolean
      },
      scrollStyle: {
        default: '',
        type: String
      }
    },
    components: { AppFooter },
    mounted () {
      this.scrollHeight = this.$store.getters.getAppHeight - 190
    },
    computed: {
      isCompactHeader: {
        get: function () {
          return this.$store.getters.getIsCompactHeader
        },
        set: function (val) {
          this.$store.commit('setIsCompactHeader', val)
        }
      },
      appHeight: {
        get: function () {
          return this.scrollHeight
        },
        set: function (height) {
          this.scrollHeight = height
        }
      },
      styleObj () {
        const height = this.appHeight
        return {
          'height': height + 'px!important',
          // 'padding-top': '0!important',
          'padding-left': '20px!important',
          'padding-right': '20px!important',
          'overflow': 'auto'
        }
      }
    },
    data () {
      return {
        isGoToTopBtn: false
      }
    },
    methods: {
      // goToTop () {
      //   const elmnt = document.getElementById('reachMeFromBottom')
      //   elmnt.scrollIntoView()
      //   document.body.scrollTop = 0 // For Safari
      //   document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
      // },
      onScroll (e) {
        const top = e.target.scrollTop
        if (top > 300) {
          this.isGoToTopBtn = true
          this.isCompactHeader = false
          this.appHeight = this.$store.getters.getAppHeight
        } else {
          this.isGoToTopBtn = false
          this.isCompactHeader = true
          this.appHeight = this.$store.getters.getAppHeight - 190
        }
      }
    }
  }
</script>

<style >
.scrollbar
{
  overflow-y: auto;
}
.scroll-style-15::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
  background-color: #F5F5F5;
  border-radius: 10px;
}

.scroll-style-15::-webkit-scrollbar
{
  width: 10px;
  background-color: #F5F5F5;
}

.scroll-style-15::-webkit-scrollbar-thumb
{
  border-radius: 10px;
  background-color: #FFF;
  background-image: -webkit-gradient(linear,
  40% 0%,
  75% 84%,
  from(#00aaee),
  to(#00a1e4),
  color-stop(.6, rgba(0, 184, 255, 0.64)))
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollData.vue